<template>
  <div class="main__wrapper">
      <h5>Form Preview: {{formTitle}}</h5>
    <el-container>
      <el-main :style="cssProps">
        <el-form>
          <template v-for="(eachFormObj, eachFormIndex) in formBody">
            <el-divider :key="`divider-${eachFormIndex}`">{{
              eachFormObj.title
            }}</el-divider>
            <el-row :key="`row-${eachFormIndex}`">
              <div class="wrapper--forms">
                <el-col
                  v-for="(field, index) in eachFormObj.fields"
                  :key="index"
                  :span="field.span"
                  v-bind="field"
                  class="form__group sm-12 xs-12"
                >
                  <!-- <label class="form__label" v-model="form.label" v-show="form.hasOwnProperty('label')">{{ form.label }}</label> -->
                  <component
                    :is="field.fieldType"
                    :currentField="field"
                    class="form__field"
                    :style="field.componentValue == null ? {border:'solid 1px red',padding:'7px'} 
                    : field.componentValue == '0' && {border:'solid 1px red',padding:'7px'}"
                  ></component>
                  <!-- <small class="form__helpblock" v-model="form.helpBlockText" v-show="form.isHelpBlockVisible">
                  {{ form.helpBlockText }}
                </small> -->
                </el-col>
              </div>
            </el-row>
          </template>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { FormBuilder } from "@Views/CustomFormBuilder/form_elements/formbuilder";
import { axiosGet, axiosPost } from "@/app/Helpers/AxiosHelper";
import {
  FORM_BUILDER_GET,
  FORM_BUILDER_RESPONSE_POST, FORM_PREVIEW,
  FORM_STATUS_STORE,
} from "@/app/Config/ApiUrl";

export default {
  name: "Publish",
  // store: ['forms', 'themingVars'],
  components: FormBuilder.$options.components,
  props: {
    Id: Number,
  },
  data() {
    return {
      inputs: {},
      forms: this.$store.state.formBuilder.forms,
      //forms: [],
      themingVars: this.$store.state.formBuilder.themingVars,
      task_id: "",
      form_id: "",
      form_body_id: 0,
      formBody:{},
      formTitle:'',
    };
  },
  methods: {
     getData() {
       axiosPost(`${FORM_PREVIEW}/${this.Id}`)
        // axiosGet(`admin/job/bid/form/2?form_id=${form_id}`)
        .then((res) => {
          if (res.data.length !== 0) {
            // this.forms = JSON.parse(res.data[0].body);

            this.inputs.form_id = res.data.form_id;
            this.formBody = res.data.formBody;
            this.formTitle = res.data.getForms.name;
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },

    getQueryParam() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      return params.get("form_id");
    },

    formStatusStore() {
      axiosPost(FORM_STATUS_STORE, this.inputs)
        .then((res) => {
          
        })
        .catch((errors) => {
          
        });
    },
  },
  mounted() {
    this.getData();
    this.$store.state.inputMode.type = false;
  },
  computed: {
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }

      return result;
    },

  },
};
</script>
<style >
.el-divider__text {
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>